import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private modalService: NgbModal) { }

  public confirm(message: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const modalRef = this.modalService.open(ConfirmDialogComponent);
      modalRef.componentInstance.title = 'Please confirm';
      modalRef.componentInstance.message = message;
      modalRef.componentInstance.changeRef.markForCheck();
      modalRef.result
        .then((result) => {
          resolve(result === true);
        }).catch((err) => {
          resolve(false);
        });
    });
  }
}
